const validate = {
  rules: {
    titulo: {
      required: true,
    },
    descricao: {
      required: true,
    },
    url_manual: {
      required: true,
    },
  },
  messages: {
    titulo: "O título é obrigatório.",
    descricao: "A descrição é obrigatória.",
    url_manual: "O arquivo do catálogo é obrigatório.",
  },
};

export default validate;
